export default {
  title: "Barème de l'impôt sur le revenu",
  subtitle: "Barème progressif applicable aux revenus de l'année {date}",
  income: {
    valueLabel: 'Revenu imposable par part',
    valueLabelTooltip:
      "Le revenu imposable par part est le montant du revenu total du foyer fiscal divisé par le nombre de parts de quotient familial. Cette division permet souvent de réduire le taux d'imposition pour les foyers avec plusieurs personnes à charge. Le revenu est réparti sur un nombre de parts plus élevé, ce qui peut entraîner une imposition moins lourde par part.",
    formattedValueLabel: "Taux marginal d'imposition",
    formattedValueLabelTooltip:
      "Le taux marginal d'imposition (TMI) représente le taux d'imposition appliqué au dernier segment de revenu taxable du contribuable.",
  },
}
